import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSuitcaseWork"><Path fillRule="evenodd" clipRule="evenodd" d="M8.75 3.5C8.61193 3.5 8.5 3.61193 8.5 3.75V6H15.5V3.75C15.5 3.61193 15.3881 3.5 15.25 3.5H8.75ZM17 6V3.75C17 2.7835 16.2165 2 15.25 2H8.75C7.7835 2 7 2.7835 7 3.75V6H3.75C2.7835 6 2 6.7835 2 7.75V19.25C2 20.2165 2.7835 21 3.75 21H20.25C21.2165 21 22 20.2165 22 19.25V7.75C22 6.7835 21.2165 6 20.25 6H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseWork;
